import { type BrandTokens, defaultTokens } from "../templates/tokens";
import type { ProfileViewModel } from "./buildViewModel";

/**
 * resolveTokens — derive the appearance tokens for a profile from the resolved
 * view model, mapping today's values 1:1 so output is unchanged (step 3b of the
 * CV-template refactor; see /CV_TEMPLATES_PLAN.md).
 *
 * Mapping:
 *   colors.primary      ← org primary   (falls back to the classic default)
 *   colors.accent       ← org accent    (today always the default #3b82f6)
 *   colors.sectionTitle ← org secondary — this is the one ClassicTemplate reads;
 *                         when there is no org theme it stays at the default
 *                         (#6b7280), matching the old ThemeContext fallback.
 *   photo               ← personal-info round mode
 * Everything else stays at the classic defaults until later steps/knobs drive it.
 */
export function resolveTokens(vm: ProfileViewModel): BrandTokens {
  const orgColors = vm.theme?.colors;

  return {
    ...defaultTokens,
    colors: {
      ...defaultTokens.colors,
      primary: orgColors?.primary ?? defaultTokens.colors.primary,
      accent: orgColors?.accent ?? defaultTokens.colors.accent,
      sectionTitle: orgColors?.secondary ?? defaultTokens.colors.sectionTitle,
    },
    photo: vm.personalInfo.roundedProfilePicture ? "round" : "square",
  };
}
